import { render, staticRenderFns } from "./ProductBrands.vue?vue&type=template&id=0a2b6d3e&"
import script from "./ProductBrands.vue?vue&type=script&lang=js&"
export * from "./ProductBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports